import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { WHITE, FONT_COLOR, HOVER_GRAY_SHADE, LIGHTER_BLACK, LIGHT_GREY, PURPLE, LIGHTER_GREY } =
	colors;
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';
import { themedCheckbox } from 'theme/theme';

const timeElementStyle = makeStyles(() => ({
	proTipText: {
		fontFamily: Bogle_Regular,
		fontSize: '14px'
	},
	root: {
		cursor: 'pointer',
		minHeight: '32px',
		paddingTop: 0,
		paddingBottom: 0,
		'&:hover': {
			backgroundColor: HOVER_GRAY_SHADE
		}
	},
	listItemRow: {
		alignItems: 'center'
	},
	listItemText: {
		fontSize: '14px',
		fontFamily: `${Bogle_Medium} !important`,
		display: 'flex',
		alignItems: 'center'
	},
	listIcon: {
		display: 'inline-flex',
		alignItems: 'center',
		marginRight: '8px',
		height: '14px'
	},
	rightAligned: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	filterIcon: {
		right: 0,
		color: WHITE,
		position: 'absolute',
		opacity: 0.0
	},
	showFilter: {
		color: FONT_COLOR,
		opacity: 1.0
	},
	highlightFilter: {
		background: '#DADCE0',
		borderRadius: 4
	},
	checkbox: themedCheckbox,
	checkboxIcon: {
		color: FONT_COLOR,
		'&:hover': {
			backgroundColor: 'unset'
		}
	},
	customWidth: {
		maxWidth: '164px',
		marginRight: 24
	},
	tooltipPanel: {
		padding: '16px'
	},
	tooltipText: {
		fontSize: '12px',
		fontFamily: 'Bogle-Meduim'
	},
	tooltipTop: {
		marginTop: '12px'
	},
	notCheckedClass: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		'&:hover': {
			width: '250px'
		}
	},
	hoverClass: {
		textOverflow: 'ellipsis',
		width: '200px',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	charterOnlyText: {
		marginTop: '-20px',
		fontSize: '12px',
		float: 'right'
	},
	pinnedItemDescription: {
		width: '238px',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis'
	},

	/* Time Range Selection */
	TimeRangeSelectionContainer: {
		top: '114px',
		zIndex: '100',
		right: '362px',
		width: '340px',
		padding: '16px',
		borderRadius: 16,
		position: 'fixed',
		backgroundColor: WHITE,
		boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.15)'
	},
	TimeRangeSelectionTitle: {
		fontSize: 14,
		fontWeight: 700,
		fontFamily: Bogle_Medium,
		color: LIGHTER_BLACK
	},
	TimeRangeSelectionContent: {
		fontSize: 12,
		fontWeight: 400
	},
	TimeRangeSelection: {
		gap: 16,
		padding: 16,
		marginTop: 16,
		display: 'flex',
		borderRadius: 8,
		border: `1px solid ${LIGHT_GREY}`,
		'& p': {
			fontSize: 12,
			fontWeight: 700
		},
		cursor: 'pointer',
		'&:hover': {
			padding: 15,
			border: `2px solid ${PURPLE}`
		}
	},
	defaultSelection: {
		width: '54px',
		marginTop: '8px',
		borderRadius: 2,
		fontSize: '12px',
		padding: '4px 8px',
		textAlign: 'center',
		backgroundColor: LIGHTER_GREY
	},
	infoContainer: {
		display: 'flex',
		gap: '4px',
		marginTop: '8px',
		padding: '4px 8px',
		borderRadius: '4px',
		'& p': {
			fontSize: '12px',
			color: '#515357'
		},
		'& svg': {
			color: '#46474A',
			width: '16px'
		}
	},
	pivotIcon: {
		width: 16,
		height: 16,
		padding: 4,
		marginRight: 4,
		borderRadius: '50%',
		'&:hover': {
			backgroundColor: LIGHT_GREY
		}
	}
}));

export default timeElementStyle;
